export function buildCalendarDays(year, month, firstDayOfWeek) {
  const dayOfWeek = new Date(year, month, 1).getDay();
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const leadingBlanks = Array((dayOfWeek - firstDayOfWeek + 7) % 7).fill(null);
  const days = Array.from({
    length: daysInMonth
  }, (_, i) => {
    const day = i + 1;
    return {
      dateStr: `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`,
      day
    };
  });
  return [...leadingBlanks, ...days];
}